import { useState } from "react";
import RestaurantQR from "../restaurantQR/restaurantQR.component";
import "./restaurant-settings.styles.scss";
import RSChange from "./rs-change/rs-change.component";
const RestaurantSettings = () => {
  const [qrClass, setQRClass] = useState("qr-class-hidden");
  const [currentPage, setCurrentPage] = useState("");
  const handleChange = (currentPage) => {
    if (qrClass === "qr-class-hidden") {
      setQRClass("qr-class-visible");
    } else if (qrClass === "qr-class-visible") {
      setQRClass("qr-class-hidden");
    }
    setCurrentPage(currentPage);
  };

  return (
    <div className="restaurant-settings-container">
      <div className={qrClass}>
        <span className="qr-class-goback" onClick={() => handleChange("")}>
          Go back
        </span>
        <RestaurantQR currentPage={currentPage} />
      </div>

      {window.innerWidth > 1024 ? (
        <div className="restaurant-settings-desktop">
          <div className="rs-qrcodes-container">
            <div className="rs-qrcodes-tableside">
              <span className="rs-qrcodes-tableside-message">
                View and download Tableside QR JPG image
              </span>
              <span
                className="rs-qrcodes-tableside-view"
                onClick={() => handleChange("tableside")}
              >
                View Tableside QR
              </span>
            </div>
            <div className="rs-qrcodes-takeaway">
              <span className="rs-qrcodes-takeaway-message">
                View and download Takeaway QR JPG image
              </span>
              <span
                className="rs-qrcodes-takeaway-view"
                onClick={() => handleChange("takeaway")}
              >
                View Takeaway QR
              </span>
            </div>
          </div>
          <div className="rs-change-title-container">
            <span className="rs-change-title">Change details</span>
          </div>
          <RSChange />
        </div>
      ) : (
        <div className="restaurant-settings-mobile">
          <div className="rs-qrcodes-container">
            <div className="rs-qrcodes-tableside">
              <span className="rs-qrcodes-tableside-message">
                View and download Tableside QR JPG image
              </span>
              <span
                className="rs-qrcodes-tableside-view"
                onClick={() => handleChange("tableside")}
              >
                View Tableside QR
              </span>
            </div>
            <div className="rs-qrcodes-takeaway">
              <span className="rs-qrcodes-takeaway-message">
                View and download Takeaway QR JPG image
              </span>
              <span
                className="rs-qrcodes-takeaway-view"
                onClick={() => handleChange("takeaway")}
              >
                View Takeaway QR
              </span>
            </div>
          </div>
          <div className="rs-change-title-container">
            <span className="rs-change-title">Change details</span>
          </div>
          <RSChange />
        </div>
      )}
    </div>
  );
};
export default RestaurantSettings;
